export const updateServiceCategoria = (api, props, controller) => {
  return api.put(`secoes_categoria/${props.id}`, props, {
    signal: controller.signal,
  });
};

export const editSecao = (api, props, controller) => {
  return api.put(`secoes_categoria/${props.id}`, props, {
    signal: controller.signal,
  });
};